import "@fontsource-variable/inter";
import "@fontsource-variable/sora";
import "@/app/globals.css";
import "@/app/classifieds.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app";
import { registerSW } from "virtual:pwa-register";

const update = registerSW({
  onNeedRefresh() {
    window.dispatchEvent(
      new CustomEvent("krosspaths-update", { detail: update }),
    );
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
